export default {
    'NOT FOUND': 'Not found',
    'You just hit a route that doesnt exist the sadness':
      "You just hit a route that doesn't exist.",
  };
  